<template>
  <div
    class="relative flex items-start"
    :class="{ 'py-4 lg:py-0': isDefault }"
  >
    <div class="min-w-0 flex-1">
      <label
        tabindex="0"
        :for="label"
        :class="{
          'lg:border-transparent': isChecked && isDefault,
          'border-transparent': isChecked && isButton,
          'lg:border-neutral-900': !isChecked && isDefault,
          'border-neutral-900': !isChecked && isButton,
          'cursor-not-allowed opacity-30': isReadonly,
          'cursor-pointer hover:opacity-70': !isReadonly,
          'lg:rounded-lg lg:border lg:p-4': isDefault,
          'py-4 px-5 rounded-lg border': isButton,
        }"
        class="min-w-0 flex-1 shrink-0 flex justify-between items-center relative"
      >
        <span
          v-if="isChecked"
          :class="{
            'hidden lg:block lg:border-bubblegum-500 lg:border-2 w-full h-full rounded-lg': isDefault,
            'border-bubblegum-500 border-2 w-full h-full rounded-lg': isButton,
          }"
          class="absolute inset-0"
        />
        <span
          :class="{
            'font-semibold text-sm': isButton,
            'text-bubblegum-500': isChecked && isButton,
          }"
          class="flex items-center space-x-4"
        >
          <fa
            v-if="icon.length"
            :icon="icon"
            class="fa-fw text-xl"
          />
          <span>{{ label }}</span>
        </span>
        <input
          :id="label"
          v-model="proxyChecked"
          :value="value"
          :aria-checked="value.toString()"
          :type="type"
          :disabled="isReadonly"
          :class="{
            'cursor-not-allowed': isReadonly,
            'cursor-pointer': !isReadonly,
            invisible: isButton,
          }"
          class="size-5 border-neutral-700 text-neutral-700 focus:ring-neutral-700 lg:focus:ring-0"
        />
      </label>
    </div>
  </div>
</template>

<script>
const Variant = {
  Default: 'default',
  Button: 'button',
};

export default {
  name: 'VetsterSearchCheckboxInput',

  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Array,
      default: () => [],
    },
    label: {
      type: String,
      required: true,
      default: '',
    },
    modelValue: {
      type: [Array, Boolean, String],
      default: false,
    },
    type: {
      type: String,
      default: 'checkbox',
    },
    value: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: Variant.Default,
      validator: (value) => Object.values(Variant).includes(value),
    },
  },

  computed: {
    isButton() {
      return this.variant === Variant.Button;
    },
    isChecked() {
      return Array.isArray(this.modelValue)
        ? this.modelValue.includes(this.value)
        : this.modelValue === this.value;
    },
    isDefault() {
      return this.variant === Variant.Default;
    },
    isReadonly() {
      return this.disabled && !this.isChecked;
    },
    proxyChecked: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
};
</script>
